import { Pipe, PipeTransform } from '@angular/core';
import { CommunicationSummary } from 'src/app/services/communications.service';

@Pipe({ name: 'communicationLogFilter' })
export class CommunicationLogFilterPipe implements PipeTransform {
  transform(values: CommunicationSummary[], filter: string): CommunicationSummary[] {
    if (!filter)
      return values;
    const term = filter.toLowerCase();
    return values.filter(item =>
      !!item && (
        this.checkValue(item.communicationId, term)
        || this.checkValue(item.requestingModule, term)
        || this.checkValue(item.subject, term)
        || this.checkValue(item.createdDate, term)
        || this.checkValue(item.createdBy, term)
        || this.checkValue(item.recipients, term)
      )
    );
  }

  checkValue(value: any, filter: string) {
    return !!value && value.toString().toLowerCase().includes(filter);
  }
}
